import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header, Gallery } from "components";
import { Button, Switch, Icon } from "antd";

class DocumentListPage extends Component {
  constructor(props) {
    super(props);
    const { type, id } = this.props.match.params;
    const { gallery } = this.props;

    this.state = {
      gallery: !gallery ? localStorage.getItem("documents[gallery]") === "true" : gallery,
      type,
      id,
    };

    this.toggleGallery = this.toggleGallery.bind(this);
  }

  toggleGallery() {
    localStorage.setItem("documents[gallery]", !this.state.gallery);
    this.setState({ gallery: !this.state.gallery });
  }

  render() {
    const { gallery, type, id } = this.state;
    const { galleryOnly } = this.props;
    const bread = [{ text: "Liste des médias" }];

    return (
      <Fragment>
        <Helmet>
          {title("Liste des médias")}
          <body data-gallery={gallery ? "1" : "0"} />
        </Helmet>

        <div className="document-list-page main-content">
          <Header title="Médias" bread={bread} />

          {!galleryOnly && (
            <div className="toggler-wrap">
              <Switch
                checked={this.state.gallery}
                onChange={this.toggleGallery}
                checkedChildren={<Icon type="appstore" />}
                unCheckedChildren={<Icon type="table" />}
              />
            </div>
          )}

          {gallery ? <Gallery type={type} id={id} /> : <List cards={false} type="documents" />}
        </div>
      </Fragment>
    );
  }
}

export default DocumentListPage;
